<template>
  <div class="report-check">
    <div class="data-content">
      <div class="table-head">
        <div class="table-title">
          <span style="font-weight: bold">用户信息及登录设备列表</span>
        </div>
        <div>
            <Input
                v-model="filterData.phone_number"
                maxlength="11"
                placeholder="用户手机号码"
                clearable
                style="min-width: 80px; width:150px; margin-right: 10px;"/>
            <Input
                v-model="filterData.serial_number"
                maxlength="6"
                placeholder="用户身份ID"
                clearable
                style="min-width: 80px; width:150px; margin-right: 10px;"/>
            <Button @click="getData()">搜索</Button>
        </div>
      </div>
      <div style="width: 100%; display: flex;">
          <div class="avatar">
              <Poptip trigger="hover" :transfer="true" title="图片详情">
                    <div class="info-pop" slot="content">
                        <img :src="user.avatar" class="img-avatar-preview">
                    </div>
                    <img :src="user.avatar" class="img-avatar">
              </Poptip>
          </div>
          <div class="report-content">
              <div class="user-nickname">{{ user.nickname }}</div>
              <div class="user-created-at">创建时间：{{ user.created_at }}</div>
              <div class="user-invite-code">身份ID：{{ user.serial_number }}</div>
              <div class="report-bottom">
                  <div class="report-desc">区号：{{ user.area_code ? '+'+user.area_code : '暂无' }} ，手机号：{{ user.phone ? user.phone : '暂无' }}</div>
                  <div class="report-desc">微信-OpenId：{{ user.wx_unionid ? user.wx_unionid : '暂无' }}</div>
                  <div class="report-desc">Apple-OpenId： {{user.apple_id ? user.apple_id : '暂无'}}</div>
                  <div class="report-desc">是否开通会员： <span :style="user.app_membership_color">{{user.membership_level >= 1 ? '是' : '否'}}</span></div>
                  <div class="report-desc">会员到期时间： <span :style="user.app_membership_color">{{user.membership_deadline ? user.membership_deadline : '暂无'}}</span></div>
                  <div class="report-desc">账号状态： <span :style="user.app_status_color">{{user.app_status}}</span></div>
                  <div class="report-desc">用户封禁放出时间： {{user.ban_released_time == "" ? '暂无' : user.ban_released_time}}</div>
                  <div class="report-desc">发言禁言放出时间： {{user.comment_released_time == "" ? '暂无' : user.comment_released_time}}</div>
               </div>
          </div>
      </div>
      <div style="margin-left: 4rem;margin-bottom: 1rem;">
          <Input
              v-model="filterData.password"
              maxlength="4"
              placeholder="用户模式密码"
              clearable
              style="min-width: 80px; width:150px; margin-right: 10px;"/>
          <Button @click="toResetUseModePwd()">重置模式密码</Button>
      </div>
      <Table :columns="columns" :data="changeDataList" @on-selection-change="selected">
        <template slot-scope="{ row, index }" slot="id">
          <span>{{ row.id }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="created_at">
          <span>{{ row.created_at }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="device_id">
         <span>{{ row.device_id }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="device_name">
          <span>{{ row.device_name }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="phone_model">
          <span>{{ row.phone_model }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="os_version">
          <span>{{ row.os_version }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="platform">
          <span>{{ row.platform }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="app_version">
          <span>{{ row.app_version }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="ip_address">
          <span>{{ row.ip_address }}</span>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import apis from "../../http/api";

export default {
  name: "ReportCheck",
  components: {},
  watch: {
  },
  data() {
    return {
      filterData: {
        phone_number:null,
        serial_number:null,
        password:null
      },
      selectedItem: [],
      selectedId: [],
      dataList: [],
      user:{'avatar':"https://cotime.cn-shanghai.oss.aliyuncs.com/app/avatar/webcotime.png",'nickname':'CoTime用户昵称','serial_number':'000000'},
      avatar: null,  // 被举报人头像
      columns: [
        {
          title: 'id',
          slot: 'id',
          align: 'center'
        },
        {
          title: '创建时间',
          slot: 'created_at',
          align: 'center'
        },
        {
          title: '设备唯一编号',
          slot: 'device_id',
          align: 'center'
        },
        {
          title: '设备/渠道',
          slot: 'device_name',
          align: 'center'
        },
        {
          title: '设备型号',
          slot: 'phone_model',
          align: 'center'
        },
        {
          title: '系统版本',
          slot: 'os_version',
          align: 'center'
        },
        {
          title: '平台',
          slot: 'platform',
          align: 'center'
        },
        {
          title: 'App版本号',
          slot: 'app_version',
          align: 'center'
        },
        {
          title: 'ip地址',
          slot: 'ip_address',
          align: 'center'
        }
      ],
    }
  },
  created() {
  },
  methods: {
    getData() {
      if(this.filterData.serial_number == undefined && this.filterData.phone_number == undefined){
          alert('请输入用户身份ID或手机号码')
          return 
      }
      let params = {
      };
      if(this.filterData.serial_number!=undefined && this.filterData.serial_number.length>0){
          params.serial_number = this.filterData.serial_number
      }
      if(this.filterData.phone_number!=undefined && this.filterData.phone_number.length>0){
          params.phone_number = this.filterData.phone_number
      }
      apis.co_time_tool_user_info(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          var list = data.device_records
          console.log(JSON.stringify(list))
          var user =data.user
          var avatar = user.avatar
          if(avatar == undefined || avatar == ""){
              avatar = "webco.png"
          }
          if(avatar.startsWith("http")){
              
          }else{
              user['avatar'] = "https://image.co-study.com.cn/app/image/avatar/"+ avatar
          }
          // 0为正常，-1为封禁, -2是注销
          var status = '正常'
          var color = {color:"#000000"}
          if(user.active == -1){
              status = '封禁'
              color = {color:'red'}
          }else if(user.active == -2){
             status = '注销'
             color = {color:'gray'}
          }else if(user.active >0){
             status = '正常'
             color = {color:'green'}
          }else{
             status = '未知'
             color = {color:"#000000"}              
          }
          user['app_status'] = status
          user['app_status_color'] = color
          var membership_color = {color:"#000000"}
          if(user.membership_level>0){
             membership_color = {color:'green'}
          }
          user['app_membership_color'] = membership_color
          if(this.filterData.serial_number == undefined ){
              this.filterData.serial_number = user.serial_number
          }
          this.user = user
          this.dataList =list;
        }else{
          alert(msg)
        }
      }).catch(err => {
        alert("接口异常")
      })
    },
    toResetUseModePwd() {
      if(this.filterData.serial_number == undefined ){
          this.$Message.error('请输入用户身份ID'); 
          return 
      }
      if(this.filterData.password == undefined || this.filterData.password.length !=4){
          this.$Message.error('请输入4位数数字密码！'); 
          return 
      }
      var numReg = /^[0-9]*$/
      var numRe = new RegExp(numReg)
      if(!numRe.test(this.filterData.password)){
        this.$Message.error('请输入4位数数字密码！'); 
        return
      }
      let params = {
        serial_number: this.filterData.serial_number,
        password: this.filterData.password
      };
      apis.co_time_tool_user_control_password_reset(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
            this.$Message.success('重置模式密码成功！'); 
        }else{
          alert(msg)
        }
      }).catch(err => {
        alert("接口异常")
      })
    },
    selected(selecttion) {
      this.selectedId = [];
      this.selectedItem = selecttion;
      selecttion.forEach(item => {
        this.selectedId.push(item.id)
      })
      console.log(this.selectedId)
    },
  },
  computed: {
    changeDataList() {
        return this.dataList.map(item => {
          return item
        })
    }
  },
  filters: {
  }
}
</script>

<style scoped>
.report-check {
  margin: 10px;
}

.clickable-span {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
}

.text-center {
  text-align: center;
}

.table-head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
}

.table-title {
  align-self: center;
}

.modal1-div {
  margin-bottom: 10px;
}

.info-pop {
  white-space: pre-wrap;
}

.avatar{
    float: left;
    width: 50px;
    margin-top: 20px;
}
.img-avatar{
    width: 50px;
    height: 50px;
    border-radius: 50%;
}
.img-avatar-preview{
    width: 400px;
    height: 400px;
}
.report-content{
    float: left;
    width: 600px;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20px;
}
.user-nickname{
    font:bold;
    float: left;
    font-size: 16px;
    width: 300px;
    color: #000000;
}
.user-created-at{
    font:normal;
    font-size: 16px;
    float: right;
    color: #cccccc;
}
.user-invite-code{
    font:bold;
    float: left;
    font-size: 14px;
    margin-top: 8px;
    width: 300px;
    color: #cccccc;
}
.user-report-type{
    font:normal;
    font-size: 14px;
     margin-top: 8px;
    float: right;
    color: #cccccc;
}
.report-bottom{
    float: left;
    margin-top: 8px;
    width: 500px;
}
.report-desc{
    font:normal;
    font-size: 16px;
    color: #000000;
}
.report-img-container{
    margin-top: 20px;
}
.report-img{
    margin-right: 20px;
}
.report-image{
   width: 80px;
   height: 80px; 
}
.report-type{
    font:bold;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #000000;
}
</style>
